import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
//components
import Select from "../../../../input/Select";
import MaskInput from "../../../../input/MaskInput";
import Toggle from "../../../../button/Toggle";

export function Contacts({
  setValue,
  getValues,
  control,
  errors,
  contacts,
  inputRequireds,
  telephones,
  setTelephones,
}) {
  const [masks, setMasks] = useState([]);

  const optionsTypeNumbers = [
    { label: "Celular", value: 1 },
    { label: "Fixo", value: 2 },
    { label: "Comercial", value: 3 },
  ];

  useEffect(() => {
    if (!contacts) return;

    if (contacts.length === 0) {
      setTelephones([{ is_default: true }]);
      setMasks(["(99) 99999-9999"]);
    } else {
      setTelephones(contacts);
      const mascarasIniciais = contacts.map((c) =>
        c.type_number === 1 ? "(99) 99999-9999" : "(99) 9999-9999"
      );
      setMasks(mascarasIniciais);

      contacts.forEach((c, idx) => {
        setValue(`contacts[${idx}]`, c.number);
        setValue(`type_numbers[${idx}]`, c.type_number);
        setValue(`is_default[${idx}]`, c.is_default || false);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contacts]);

  useEffect(() => {
    telephones.map((t, index) => {
      setValue(`contacts[${index}]`, t.number);
      setValue(`type_numbers[${index}]`, t.type_number);
      setValue(`is_default[${index}]`, t.is_default || false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [telephones]);

  const handleAddTelephone = () => {
    setTelephones([...telephones, { is_default: false }]);
    setMasks([...masks, "(99) 99999-9999"]);
  };

  const getFormErrorMessage = (name) => {
    return errors[name] ? (
      <small className="p-error">{errors[name].message}</small>
    ) : (
      <small className="p-error">&nbsp;</small>
    );
  };

  const handleRemoveTelephone = (index) => {
    setTelephones((prevTelephones) =>
      prevTelephones.filter((_, i) => i !== index)
    );
    setMasks((prevMasks) => prevMasks.filter((_, i) => i !== index));
  };

  const handleChangeInput = (index) => {
    const updateTelephones = [...telephones];
    updateTelephones[index] = {
      ...updateTelephones[index],
      number: getValues(`contacts[${index}]`),
      type_number: getValues(`type_numbers[${index}]`),
      is_default: getValues(`is_default[${index}]`) || false,
    };
    setTelephones(updateTelephones);
  };

  const handleChangeSelect = (index, tipoSelecionado) => {
    const updateTelephones = [...telephones];
    updateTelephones[index] = {
      ...updateTelephones[index],
      type_number: tipoSelecionado,
      number: getValues(`contacts[${index}]`),
      is_default: getValues(`is_default[${index}]`) || false,
    };
    setTelephones(updateTelephones);

    setMasks((prev) => {
      const copia = [...prev];
      copia[index] =
        tipoSelecionado === 1 ? "(99) 99999-9999" : "(99) 9999-9999";
      return copia;
    });
  };

  const handleToggleDefault = (index, isDefault) => {
    const updateTelephones = [...telephones];

    // Se está marcando como padrão, desmarca todos os outros
    if (isDefault) {
      updateTelephones.forEach((phone, idx) => {
        phone.is_default = idx === index;
        setValue(`is_default[${idx}]`, idx === index);
      });
    } else {
      // Se está desmarcando, apenas atualiza o atual
      updateTelephones[index].is_default = false;
      setValue(`is_default[${index}]`, false);
    }

    setTelephones(updateTelephones);
  };
  return (
    <>
      {telephones.map((_, index) => (
        <div className="row d-flex" key={index}>
          <div className="col-md-3">
            <Select
              name={`type_numbers[${index}]`}
              label={`Tipo ${
                inputRequireds?.includes("contacts") && index === 0 ? "*" : ""
              }`}
              errors={errors}
              isRequired={inputRequireds?.includes("contacts") && index === 0}
              onChange={(e) => {
                handleChangeInput(index);
                handleChangeSelect(index, e);
              }}
              control={control}
              options={optionsTypeNumbers}
            />
          </div>
          <div className="col-md-4">
            <MaskInput
              name={`contacts[${index}]`}
              mask={masks[index]}
              control={control}
              errors={errors}
              isRequired={inputRequireds?.includes("contacts") && index === 0}
              label={`Telefone ${
                inputRequireds?.includes("contacts") && index === 0 ? "*" : ""
              }`}
              onChange={() => handleChangeInput(index)}
            />
          </div>
          <div className="col-md-2 mt-4">
            <Toggle
              name={`is_default[${index}]`}
              control={control}
              onLabel="Principal"
              offLabel="Normal"
              onChange={(value) => handleToggleDefault(index, value)}
              className="w-100"
              getFormErrorMessage={getFormErrorMessage}
            />
          </div>
          <div className="col-md-3 mt-4 pt-2">
            {index > 0 && (
              <Button
                rounded
                outlined
                severity="danger"
                icon="fa fa-minus"
                onClick={() => handleRemoveTelephone(index)}
                style={{ width: "2rem", height: "2rem", padding: "2px" }}
              />
            )}
            {index === telephones.length - 1 && (
              <Button
                rounded
                outlined
                size="small"
                icon="fa fa-plus"
                onClick={handleAddTelephone}
                className="mx-2"
                style={{ width: "2rem", height: "2rem", padding: "2px" }}
              />
            )}
          </div>
        </div>
      ))}
    </>
  );
}
